import Swiper, { Autoplay, Pagination } from 'swiper'

Swiper.use([Autoplay, Pagination]);

function initTestimonialCarousels() {

  const testimonialCarousels = Array.from(document.querySelectorAll('.js-testimonial-carousel'));

  testimonialCarousels.forEach(testimonialCarousel => {

    const paginationEl = testimonialCarousel.querySelector('.js-testimonial-pagination');

    const swiper = new Swiper(testimonialCarousel, {
      loop: false,
      speed: 800,
      grabCursor: true,
      slidesPerView: 1,
      autoplay: {
        delay: 8000
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      }
    });

    const slides = Array.from(testimonialCarousel.querySelectorAll('.js-testimonial-slide'));
    const slideLogos = []
    const paginationBullets = Array.from(paginationEl.querySelectorAll('.swiper-pagination-bullet'));

    slides.forEach(slide => {
      slideLogos.push(slide.dataset.logo)
    });

    paginationBullets.forEach((paginationBullet, i) => {
      paginationBullet.style.backgroundImage = "url('" + slideLogos[i] + "')";
    })

  })
}
initTestimonialCarousels();
